// @core/api/endpoints/secret/list_audit_entries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditEntriesResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * List audit entries
 * Returns audit trail entries, optionally filtered by operation, path, actor, or time range.
 */
export async function ListAuditEntries(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    from?: string | number | boolean;
    limit?: string | number | boolean;
    operation?: string | number | boolean;
    path?: string | number | boolean;
    sort?: string | number | boolean;
    to?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListAuditEntriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit`;
  const requestOptions = options;
  return client.get<ListAuditEntriesResponse>(requestPath, { ...requestOptions, params });
}
